import { apiAxiosCMS } from 'services/api';
import { BlogProps } from 'types/BlogProps';
import { getBlogs } from 'pages/Blog/reqs';

export async function addBlog(
	dataForm: BlogProps,
	setBlogs: React.Dispatch<React.SetStateAction<BlogProps[]>>,
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	sizeList: number,
	handleNotify: any
) {
	setIsLoad(true);
	const payload: any = dataForm;

	delete payload.id;

	await apiAxiosCMS
		.post('/blog', payload)
		.then(async () => {
			setBlogs(await getBlogs(setIsLoad, handleNotify));
			handleNotify('Blog adicionado com sucesso!', 'success');
		})
		.catch(() => {
			setIsLoad(false);
			handleNotify('Algum erro aconteceu ao tentar adicionar o blog.', 'error');
		});
}

function findPositionInList(list: BlogProps[], id: string) {
	return list.findIndex((item) => item.id === id);
}

export async function editBlog(
	dataForm: BlogProps,
	blogToEdtit: BlogProps | null,
	setBlogs: React.Dispatch<React.SetStateAction<BlogProps[]>>,
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	blogs: BlogProps[],
	handleNotify: any
) {
	setIsLoad(true);
	const payload: any = dataForm;

	payload.position = findPositionInList(blogs, blogToEdtit?.id || '');
	delete payload.id;

	await apiAxiosCMS
		.patch(`blog/${blogToEdtit?.id}`, payload)
		.then(async () => {
			setBlogs(await getBlogs(setIsLoad, handleNotify));
			handleNotify('Blog editado com sucesso!', 'success');
		})
		.catch(() => {
			setIsLoad(false);
			handleNotify('Algum erro aconteceu ao tentar editar o blog.', 'error');
		});
}
